import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { Default, Expose, ItemModel, ModelId } from '@core/shared/model';
import { SceneUserProgressRestraints } from './scene-user-progress.restraints';
let SceneUserProgressItem = /*#__PURE__*/(() => {
  let SceneUserProgressItem = class SceneUserProgressItem extends ItemModel {
    toString() {
      return `SceneUserProgress (${this.sceneId},${this.ownerId})`;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], SceneUserProgressItem.prototype, "updateDate", void 0);
  __decorate([Expose(), Default(null), __metadata("design:type", Number)], SceneUserProgressItem.prototype, "sceneId", void 0);
  __decorate([Expose(), Default(null), __metadata("design:type", Number)], SceneUserProgressItem.prototype, "ownerId", void 0);
  __decorate([Expose()
  // @IsNumber()
  , Default(0), __metadata("design:type", Number)], SceneUserProgressItem.prototype, "progress", void 0);
  __decorate([Expose(), Default(false), __metadata("design:type", Boolean)], SceneUserProgressItem.prototype, "completed", void 0);
  SceneUserProgressItem = __decorate([UseRestraints(SceneUserProgressRestraints), ModelId("SceneUserProgressItem") // auto-generated by generate-model-ids
  ], SceneUserProgressItem);
  return SceneUserProgressItem;
})();
export { SceneUserProgressItem };